import React from "react";
import { useHistory } from "react-router-dom";
import { IonIcon, IonButtons } from "@ionic/react";
import { AuthMode } from "@ionic-enterprise/identity-vault";
import { useTracked } from "../../state";
import { identityService } from "../../services/vault";
import lock from "../../assets/svg/lock.svg";
import { setMobileIsAppLockedState } from "../../utils/helpers/LocalStorage";

interface Props {
  authMode: any;
  biometricType: any;
  hasSession: boolean;
}

const LockButtonIcon: React.FC<Props> = React.memo(
  ({ authMode, biometricType, hasSession }) => {
    const [, dispatch] = useTracked();
    // useeHistory causes rerender
    const history = useHistory();

    const handleLock = async () => {
      if (biometricType && biometricType !== "none" && hasSession) {
        await identityService.lockOut();
        setMobileIsAppLockedState(true);
        dispatch({ type: "logout", appId: process.env.REACT_APP_APP_ID });
        history.push("/", { direction: "none" });
      }
    };

    return (
      <React.Fragment>
        {(authMode !== AuthMode.SecureStorage &&
          authMode !== AuthMode.InMemoryOnly) && (
          <IonButtons slot="end">
            <IonIcon className="lock-icon" icon={lock} onClick={handleLock} />
          </IonButtons>
        )}
      </React.Fragment>
    );
  }
);

const MemoizedLockButtonIcon = () => {
  const [state] = useTracked();
  const { authMode, biometricType, hasSession } = state;

  return (
    <LockButtonIcon
      authMode={authMode}
      biometricType={biometricType}
      hasSession={hasSession}
    />
  );
};

export default MemoizedLockButtonIcon;
